<script lang="ts">
  import { SellerPreference } from "$lib/utils";

  export let sellPreference: string;
  export let availability: number;

  let rules: string;
  function showMessage(preference: string) {
    switch (preference) {
      case SellerPreference.ALL_TOGETHER:
      case SellerPreference.IN_PAIRS:
      case SellerPreference.NO_PREFERENCE:
      default:
        rules =
          "We can guarantee up to 4 seats. For example if you order 6, you will receive a 4 and a 2 together (unless in Notes single seats or Up to 2 specified).";
        break;
    }
  }
  $: showMessage(sellPreference);
</script>

<div class="seat">
  {#if availability !== 1}
    <i />
    <p>
      <span class="pf-400">Seated together</span>
      <span class="pf-300">{rules}</span>
    </p>
  {/if}
</div>

<style lang="scss">
  .seat {
    display: grid;
    grid-template-columns: 1em auto;
    gap: 1em;
    text-align: start;
    span {
      line-height: 120%;
    }
    p {
      margin: 0;
      display: grid;
    }
    i {
      display: block;
      width: 1em;
      height: 1em;
      background: url(../_assets/together.svg);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cove;
    }
    .pf-300 {
      font-size: 0.8em;
    }
  }
</style>
